import FormCard from "@/containers/Auth/FormCard";
import Login from "@/containers/Login";
import PublicLayout from "@/containers/PublicLayout";
import useSearchParams from "@/hooks/useSearchParams";
import { ROUTES } from "@/routes_new";
import AllEarsTitle from "@components/AllEarsTitle";
import Typography from "@components/Typography";

import styles from "./LoginView.module.css";

const LoginView = () => {
  const [{ next }] = useSearchParams<{ next?: string }>();

  const handleLogin = () => {
    // When the dependency on __INITIAL_STATE__ is gone we can use a react-router redirect here.
    location.href = next || ROUTES.APP_HOME;
  };

  return (
    <PublicLayout className={styles.root}>
      <AllEarsTitle title={L.LOGIN_TITLE} />
      <div className={styles.inner}>
        <FormCard>
          <div className={styles.login}>
            <Typography
              variant="h1"
              block
              align="center"
              className={styles.title}
            >
              {L.LOGIN_CTA}
            </Typography>
            <Login onLogin={handleLogin} />
          </div>
        </FormCard>
      </div>
    </PublicLayout>
  );
};
export default LoginView;
